import format from 'date-fns/format';
import 'normalize.css';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueAuthenticate from 'vue-authenticate';
import VueShortKey from 'vue-shortkey';
import VueTheMask from 'vue-the-mask';
import Vuelidate from 'vuelidate';
import App from './App';
import registerAxios from './axios';
import { httpRequestInterceptor, httpResponseInterceptor, httpResponseSuccessInterceptor } from './http';
import registerVuetify from './vuetify';
// import registerGoogleMap from './google-map';
import './config';
import './directives/global';
import registerFilters from './filters/global';
import globalMixin from './mixins/global';
import vueRouter from './router';
import helper from './shared/helper';

Vue.use(VueShortKey);
Vue.use(VueTheMask);
Vue.use(Vuelidate);
Vue.use(VueAnalytics, {
	id: 'UA-119752111-1',
	autoTracking: {
		screenview: true,
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'devquipu.netlify.com',
});
Vue.use(VueAuthenticate, {
	baseUrl: process.env.ACL_URL,
	providers: {
		facebook: {
			clientId: process.env.FACEBOOK_API_KEY,
			redirectUri: 'http://localhost:9001',
		},
	},
});

const userInfo = helper.getLocalData('admin-user');
const router = vueRouter(Vue);
registerFilters(Vue);
registerVuetify(Vue);
registerAxios(Vue);
// registerGoogleMap(Vue);
Vue.prototype.$today = format(new Date(), 'YYYY-MM-DD');
Vue.prototype.$bus = new Vue();
Vue.prototype.$imageUrl = process.env.S3_IMAGES_URL;
Vue.prototype.$s3Static = process.env.S3_STATIC;
Vue.prototype.$userInfo = userInfo;
Vue.config.productionTip = false;
Vue.mixin(globalMixin);

async function created() {
	this.$bus.$on('USER_INFO', (user) => {
		Vue.prototype.$userInfo = user;
	});
	this.$http.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpProductsRead.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpProduction.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpSales.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpSalesRead.interceptors.request.use(this.httpRequestInterceptor);
	this.$http.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpProductsRead.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpAcl.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpMiddleware.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpSales.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpSalesRead.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpProduction.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpProducts.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpProducts.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpQuipu.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpQuipu.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpAccount.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpAccount.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpReports.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpReports.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpFacSunat.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpFacSunat.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	const token = helper.getLocalToken();
	if (token) {
		const responseJapi = await this.$httpSales.get('employees/current');
		const userJapi = responseJapi.data;
		helper.setLocalData('acl-id', userJapi.aclUserId);
		helper.setLocalData('acl-code', userJapi.aclUserCode);
		helper.setLocalData('admin-user', userJapi);
		this.$bus.$emit('USER_INFO', userJapi);
		this.$ga.set('userId', userJapi.aclUserCode);
	}
}

/* eslint-disable no-new */
new Vue({
	created,
	el: '#app',
	methods: {
		httpRequestInterceptor,
		httpResponseInterceptor,
		httpResponseSuccessInterceptor,
	},
	router,
	render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js